// UI
import { PageTemplateLink } from "@/templates/PageTemplate"

// Context
import { useCurrentHasValidBankDetails, useFeatureFlags } from "@/context/user"

// Translations
import { useTrans } from "@/i18n"

// Pages
import { Routes } from "@/constants/routes"

/**
 * Profile header component
 * @returns Profile header component
 */
export const ProfileSubMenuTabs = () => {
	const t = useTrans("profile")
	const { getFeatureFlagValue } = useFeatureFlags()
	const hasValidBankDetails = useCurrentHasValidBankDetails()

	return (
		<>
			<PageTemplateLink
				to={Routes.SettingsProfilePersonalDetails}
				data-testid="profile.personal_details"
				name={t("profile:profile.personal_details.title")}
				analyticsId="profile.personal_details"
			/>

			{/** Show tab only if user has organisation account */}
			<PageTemplateLink
				to={Routes.SettingsProfileCompanyDetails}
				data-testid="profile.company_details"
				name={t("profile:profile.company_details.title")}
				analyticsId="profile.company_details"
			/>

			{/** Bank details */}
			<PageTemplateLink
				to={Routes.SettingsProfileBankDetails}
				data-testid="profile.bank_details"
				name={t("profile:profile.bank_details.title")}
				analyticsId="profile.bank_details"
				badgeNumber={hasValidBankDetails ? 0 : 1}
				badge={{
					type: hasValidBankDetails ? "verified" : undefined,
				}}
			/>

			{/** Account settings */}
			<PageTemplateLink
				to={Routes.SettingsProfileAccount}
				data-testid="profile.account"
				name={t("profile:profile.account_settings.title")}
				analyticsId="profile.account"
			/>

			<PageTemplateLink
				to={Routes.AppSettings}
				data-testid="settings.app"
				name={t("profile:profile.settings.app")}
				analyticsId="settings.app"
			/>

			{getFeatureFlagValue("ENABLE_MFA_SECURITY_PAGE") === true && (
				<PageTemplateLink
					to={Routes.SettingsProfileSecurity}
					data-testid="profile.security"
					name={t("profile:profile.security.title")}
					analyticsId="profile.security"
					end={false}
				/>
			)}
		</>
	)
}
